/**
 * A/B Test: PDP social proof reviews (Elios)
 *
 * body attribute (IntelliGems / AB tool):
 *   data-elios-social-proof-test="false" → Control — keep existing "4.8/5 Excellent …" row
 *   data-elios-social-proof-test="true"  → Variant — hide that row; show avatars +
 *                                          "Sarah" + 10K+ happy customers (top);
 *                                          stars + dynamic score/count from original row (bottom)
 *
 * Dev preview: ?elios_social_proof_test=b  (or true / 1)
 */
(function () {
  'use strict';

  if (window.__eliosSocialProofABTestInit) return;
  window.__eliosSocialProofABTestInit = true;

  var BODY_ATTR = 'data-elios-social-proof-test';
  var VARIANT_ATTR = 'data-elios-sp-variant';
  var RATING_HIDDEN_ATTR = 'data-elios-sp-rating-hidden';
  var ACTIVE_CLASS = 'elios-social-proof-ab--active';
  var FIXED_NAME = 'Sarah';
  var HAPPY_COUNT = '10K+';
  var STAR_PATH =
    'M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.77l-4.94 2.94.94-5.5-4-3.9 5.53-.8L10 1.5z';

  var AVATARS = [
    'https://randomuser.me/api/portraits/women/44.jpg',
    'https://randomuser.me/api/portraits/women/68.jpg',
    'https://randomuser.me/api/portraits/women/21.jpg',
    'https://randomuser.me/api/portraits/women/65.jpg',
    'https://randomuser.me/api/portraits/women/33.jpg',
    'https://randomuser.me/api/portraits/women/12.jpg'
  ];

  var applying = false;
  var rafScheduled = false;
  var lastEnabled = null;

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('elios_social_proof_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function getBodyAttr() {
    if (document.body && document.body.hasAttribute(BODY_ATTR)) {
      return document.body.getAttribute(BODY_ATTR);
    }
    if (document.documentElement && document.documentElement.hasAttribute(BODY_ATTR)) {
      return document.documentElement.getAttribute(BODY_ATTR);
    }
    return null;
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    return isTruthy(getBodyAttr());
  }

  function isProductPage() {
    if (!document.body) return false;
    if (document.body.classList.contains('template-product')) return true;
    return /\/products\//.test(window.location.pathname || '');
  }

  function isFrench() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('fr') === 0;
  }

  function hashString(value) {
    var hash = 0;
    var str = String(value || '');
    for (var i = 0; i < str.length; i += 1) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function pickName() {
    return FIXED_NAME;
  }

  function pickAvatars() {
    var seed = (window.location.pathname || '') + FIXED_NAME;
    var h = hashString(seed);
    var out = [];
    var used = {};
    var i = 0;
    while (out.length < 3 && i < AVATARS.length * 2) {
      var idx = (h + i * 3) % AVATARS.length;
      if (!used[idx]) {
        used[idx] = true;
        out.push(AVATARS[idx]);
      }
      i += 1;
    }
    while (out.length < 3) out.push(AVATARS[out.length % AVATARS.length]);
    return out;
  }

  function formatReviewCount(rawCount, de) {
    var count = String(rawCount || '').replace(/\s/g, '');
    if (!count) return de ? '1 800+' : '1,800+';

    if (/^\d+$/.test(count)) {
      try {
        return Number(count).toLocaleString(de ? 'fr-FR' : 'en-US');
      } catch (e) {
        return count;
      }
    }

    if (/^\d+\+$/.test(count)) {
      var n = count.slice(0, -1);
      try {
        return Number(n).toLocaleString(de ? 'fr-FR' : 'en-US') + '+';
      } catch (e2) {
        return count;
      }
    }

    return count;
  }

  function getRatingRow() {
    var row =
      document.querySelector('a.social-proof-slide__block-rating') ||
      document.querySelector('.social-proof-slide__block-rating') ||
      document.querySelector('a.js-scroll-to-rating');
    if (row) return row;

    var candidates = document.querySelectorAll('.product-info a, .product-info__block-item a, .product-info span');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = (candidates[i].textContent || '').toLowerCase();
      if (
        (text.indexOf('excellent') > -1 || text.indexOf('4.8') > -1) &&
        (text.indexOf('review') > -1 || text.indexOf('avis') > -1)
      ) {
        return candidates[i].closest('a, .product-info__block-item, div') || candidates[i];
      }
    }
    return null;
  }

  function getTitleEl() {
    return (
      document.querySelector('.product-info__title') ||
      document.querySelector('h1.product-title') ||
      document.querySelector('.product-info h1') ||
      document.querySelector('product-info h1')
    );
  }

  function parseReviewStats(ratingRow) {
    var score = '4.8';
    var reviewCount = '';
    var de = isFrench();
    var source = ratingRow || getRatingRow();

    if (source) {
      var raw = (source.textContent || '').replace(/\s+/g, ' ').trim();
      var scoreMatch = raw.match(/(\d+[.,]\d+)/);
      if (scoreMatch) score = scoreMatch[1].replace(',', '.');

      // Dynamic review count from existing PDP row (e.g. "1800+ Avis")
      var countMatch =
        raw.match(/([\d.,\s]+\+?)\s*(?:reviews?|avis)/i) ||
        raw.match(/\(([\d.,\s]+\+?)\s*(?:reviews?|avis)\)/i) ||
        raw.match(/([\d.,]+\+)/);
      if (countMatch) reviewCount = countMatch[1];
    }

    reviewCount = formatReviewCount(reviewCount, de);
    var displayScore = de ? String(score).replace('.', ',') : score;

    return {
      score: score,
      displayScore: displayScore,
      count: reviewCount,
      // Top line: fixed marketing copy
      purchase: de ? 'et ' + HAPPY_COUNT + ' clientes satisfaites' : 'and ' + HAPPY_COUNT + ' happy customers',
      // Bottom line: dynamic score + count from page
      rating: de
        ? displayScore + ' / 5 (' + reviewCount + ' avis)'
        : displayScore + ' / 5 (' + reviewCount + ' reviews)'
    };
  }

  function starMarkup(fill) {
    var pct = Math.round(Math.min(1, Math.max(0, fill)) * 100);
    return (
      '<span class="elios-sp-ab__star">' +
      '<svg class="elios-sp-ab__star-bg" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="' +
      STAR_PATH +
      '"/></svg>' +
      '<span class="elios-sp-ab__star-fill" style="width:' +
      pct +
      '%">' +
      '<svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="' +
      STAR_PATH +
      '"/></svg>' +
      '</span>' +
      '</span>'
    );
  }

  function renderStars(score) {
    var value = parseFloat(score);
    if (isNaN(value)) value = 4.8;
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      var fill = Math.min(1, Math.max(0, value - (i - 1)));
      html += starMarkup(fill);
    }
    return html;
  }

  function resolveHrefTarget(href) {
    if (!href) return null;
    href = String(href).trim();
    if (!href) return null;

    if (href.charAt(0) === '#') {
      var id = href.slice(1);
      return document.getElementById(id) || document.querySelector(href);
    }

    try {
      var url = new URL(href, window.location.href);
      if (url.hash) {
        var hashId = url.hash.slice(1);
        return document.getElementById(hashId) || document.querySelector(url.hash);
      }
    } catch (e) {}

    return null;
  }

  function getReviewsSection() {
    var ratingRow = getRatingRow();
    if (ratingRow && ratingRow.getAttribute) {
      var byHref = resolveHrefTarget(ratingRow.getAttribute('href'));
      if (byHref) return byHref.closest('.shopify-section') || byHref;
    }

    // Prefer real reviews carousel / trustpilot blocks
    var preferred = [
      '.avis-elios-wrapper',
      '#trustpilot-section',
      '.trustpilot-clean',
      '[id*="custom_liquid_XUagNF"]',
      '[id*="custom_liquid_6YzLzj"]'
    ];

    for (var i = 0; i < preferred.length; i += 1) {
      var el = document.querySelector(preferred[i]);
      if (el) return el.closest('.shopify-section') || el;
    }

    // Heading-based fallback: "avis" / "reviews" section titles
    var headings = document.querySelectorAll('h1, h2, h3, .h2, .h3');
    for (var h = 0; h < headings.length; h += 1) {
      var t = ((headings[h].textContent || '') + '').toLowerCase();
      if (
        t.indexOf('avis') > -1 ||
        t.indexOf('reviews') > -1 ||
        t.indexOf('clientes en parlent') > -1 ||
        t.indexOf('nos clientes') > -1
      ) {
        return headings[h].closest('.shopify-section') || headings[h];
      }
    }

    return null;
  }

  var scrollRetry = 0;

  function scrollToReviews(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    var sec = getReviewsSection();
    if (!sec) {
      if (scrollRetry < 12) {
        scrollRetry += 1;
        window.setTimeout(function () {
          scrollToReviews(null);
        }, 200);
      }
      return;
    }

    scrollRetry = 0;

    var shopifySection = sec.closest ? sec.closest('.shopify-section') || sec : sec;
    var header =
      document.querySelector('.shopify-section--header') ||
      document.querySelector('store-header') ||
      document.querySelector('header');
    var offset = 24;
    if (header) {
      var position = window.getComputedStyle(header).position;
      if (position === 'fixed' || position === 'sticky') {
        offset += header.getBoundingClientRect().height;
      }
    }

    // Ensure sticky header offset CSS is respected if present
    try {
      shopifySection.style.scrollMarginTop = offset + 'px';
    } catch (err) {}

    var top = shopifySection.getBoundingClientRect().top + window.pageYOffset - offset;

    try {
      shopifySection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err2) {}

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

    // Keep hash in sync with original rating link when available
    var ratingRow = getRatingRow();
    var href = ratingRow && ratingRow.getAttribute ? ratingRow.getAttribute('href') : '';
    if (href && href.charAt(0) === '#' && shopifySection.id) {
      try {
        history.replaceState(null, '', '#' + shopifySection.id);
      } catch (err3) {}
    }
  }

  function wireVariantClick(root) {
    if (!root) return;
    root.setAttribute('role', 'link');
    root.setAttribute('tabindex', '0');
    root.setAttribute('title', isFrench() ? 'Voir les avis' : 'See reviews');
    root.style.cursor = 'pointer';

    if (root.getAttribute('data-elios-sp-click') === '1') return;
    root.setAttribute('data-elios-sp-click', '1');

    root.addEventListener(
      'click',
      function (e) {
        scrollToReviews(e);
      },
      true
    );

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews(e);
      }
    });
  }

  function placeVariant(root) {
    if (!root) return;

    var title = getTitleEl();
    if (title && title.parentNode) {
      if (root.nextSibling !== title) {
        title.parentNode.insertBefore(root, title);
      }
      return;
    }

    var ratingRow = getRatingRow();
    if (ratingRow && ratingRow.parentNode && root.nextSibling !== ratingRow) {
      ratingRow.parentNode.insertBefore(root, ratingRow);
    }
  }

  function ensureVariant(ratingRow, labels) {
    var existing = document.querySelector('[' + VARIANT_ATTR + ']');
    if (existing) {
      placeVariant(existing);
      wireVariantClick(existing);
      return existing;
    }

    labels = labels || parseReviewStats(ratingRow);
    var avatars = pickAvatars();
    var root = document.createElement('div');
    root.setAttribute(VARIANT_ATTR, 'true');
    root.className = 'elios-sp-ab';
    root.hidden = true;
    root.setAttribute('aria-label', isFrench() ? 'Avis clients' : 'Customer reviews');
    root.innerHTML =
      '<div class="elios-sp-ab__social-row">' +
      '<div class="elios-sp-ab__avatars" aria-hidden="true">' +
      '<img src="' +
      avatars[0] +
      '" alt="" width="30" height="30" loading="lazy">' +
      '<img src="' +
      avatars[1] +
      '" alt="" width="30" height="30" loading="lazy">' +
      '<img src="' +
      avatars[2] +
      '" alt="" width="30" height="30" loading="lazy">' +
      '</div>' +
      '<p class="elios-sp-ab__purchase-text">' +
      '<strong class="elios-sp-ab__name" data-elios-sp-name>' +
      FIXED_NAME +
      '</strong>' +
      '<span class="elios-sp-ab__verified" aria-label="Verified">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="7" cy="7" r="7" fill="#1877F2"/>' +
      '<path d="M4 7.2L6.1 9.3L10 5.3" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span> ' +
      '<span data-elios-sp-purchase>' +
      labels.purchase +
      '</span>' +
      '</p>' +
      '</div>' +
      '<div class="elios-sp-ab__rating-row">' +
      '<div class="elios-sp-ab__stars" data-elios-sp-stars aria-hidden="true">' +
      renderStars(labels.score) +
      '</div>' +
      '<span class="elios-sp-ab__rating-text" data-elios-sp-rating>' +
      labels.rating +
      '</span>' +
      '</div>';

    placeVariant(root);
    wireVariantClick(root);
    return root;
  }

  function setHidden(el, attr, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute(attr, 'true');
      el.style.display = 'none';
    } else {
      el.removeAttribute(attr);
      el.style.display = '';
    }
  }

  function apply() {
    if (applying) return;
    applying = true;

    try {
      if (!isProductPage()) {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        return;
      }

      var enabled = isAbEnabled();
      var ratingRow = getRatingRow();
      var labels = parseReviewStats(ratingRow);
      var variant = ensureVariant(ratingRow, labels);

      if (variant) {
        var ratingText = variant.querySelector('[data-elios-sp-rating]');
        var purchaseText = variant.querySelector('[data-elios-sp-purchase]');
        var nameEl = variant.querySelector('[data-elios-sp-name], .elios-sp-ab__name');
        var starsEl = variant.querySelector('[data-elios-sp-stars]');

        if (nameEl && nameEl.textContent !== FIXED_NAME) {
          nameEl.textContent = FIXED_NAME;
        }
        if (ratingText && ratingText.textContent !== labels.rating) {
          ratingText.textContent = labels.rating;
        }
        if (purchaseText && purchaseText.textContent !== labels.purchase) {
          purchaseText.textContent = labels.purchase;
        }
        if (starsEl && starsEl.getAttribute('data-score') !== String(labels.score)) {
          starsEl.innerHTML = renderStars(labels.score);
          starsEl.setAttribute('data-score', String(labels.score));
        }
        wireVariantClick(variant);
      }

      if (enabled) {
        document.documentElement.classList.add(ACTIVE_CLASS);
        if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true' && isDevVariantB()) {
          document.body.setAttribute(BODY_ATTR, 'true');
        }
        if (variant) {
          variant.hidden = false;
          variant.style.display = '';
        }
        setHidden(ratingRow, RATING_HIDDEN_ATTR, true);
      } else {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        if (variant) variant.hidden = true;
        setHidden(ratingRow, RATING_HIDDEN_ATTR, false);
      }

      lastEnabled = enabled;
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      apply();
    });
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    scheduleApply();

    if (!document.body) return;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var root = target.closest('[' + VARIANT_ATTR + '], .elios-sp-ab');
        if (!root) return;
        if (root.hidden && root.style.display === 'none') return;
        scrollToReviews(event);
      },
      true
    );

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (
          mutations[i].type === 'attributes' &&
          (mutations[i].attributeName === BODY_ATTR ||
            mutations[i].attributeName === 'data-gem-variant' ||
            mutations[i].attributeName === 'data-gem-test-active')
        ) {
          scheduleApply();
          return;
        }
        if (mutations[i].type === 'childList') {
          scheduleApply();
          return;
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active'],
      childList: true,
      subtree: true
    });

    if (document.documentElement) {
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [BODY_ATTR]
      });
    }

    document.addEventListener('shopify:section:load', scheduleApply);
  }

  window.EliosSocialProofABTest = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      scheduleApply();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      scheduleApply();
    },
    isActive: isAbEnabled,
    hydrate: scheduleApply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
